// ABOUTME: Decorative background layer for maintenance page
// ABOUTME: Radial gradient glows and blur circles matching app visual identity

export function MaintenanceBackground() {
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden">
      {/* Radial glow - blue-violet */}
      <div
        className="absolute top-1/4 left-1/3 size-[500px] rounded-full opacity-15 blur-3xl"
        style={{
          background:
            "radial-gradient(circle, oklch(0.5854 0.2041 277.12) 0%, transparent 70%)",
        }}
      />

      {/* Radial glow - purple */}
      <div
        className="absolute bottom-1/4 right-1/4 size-[400px] rounded-full opacity-10 blur-3xl"
        style={{
          background:
            "radial-gradient(circle, oklch(0.5012 0.1384 304.73) 0%, transparent 70%)",
        }}
      />

      {/* Decorative blur circles */}
      <div className="absolute top-1/6 right-1/3 size-48 rounded-full bg-primary/5 blur-2xl" />
      <div className="absolute bottom-1/3 left-1/6 size-32 rounded-full bg-primary/5 blur-xl" />
    </div>
  );
}
